export const syncNotifications = /* GraphQL */ `
  query SyncNotifications(
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncNotifications(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        createdBy
        type
        message
        popupDate
        expirationDate
        status
        createdAt
        buildingId
        building {
          id
          name
          addressId
          acquisitionValue
          acquisitionAdditionalCostsValue
          acquisitionAdvertisedValue
          amountOfFacades
          amountOfFloors
          amountOfHousings
          buildingState
          cadastralIncome
          constructionYear
          janitor
          jointOwnershipId
          propertyTax
          residenceName
          readers
          teams
          readId
          clientId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        unitId
        unit {
          id
          acquisitionAdditionalCostsValue
          acquisitionAdvertisedValue
          acquisitionValue
          advertisedMonthlyCharges
          advertisedRentalPrice
          cadastralIncome
          createdAt
          floor
          jointOwnershipId
          managementDate
          name
          predictedPrice
          propertyTax
          publishAddress
          surface
          type
          buildingId
          unitAdvertisementId
          readers
          readId
          clientId
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        leaseId
        lease {
          id
          balance
          canBeExtended
          createdAt
          endDate
          includeRealEstateInLeaseContract
          invoiceSenderId
          inventoryOfFixturesExpert
          inventoryOfFixturesMethod
          inventoryOfFixturesType
          ipiNumber
          language
          lastIndexationProcessDate
          lastInvoiceDate
          legalCompetentAuthority
          name
          paymentFrequency
          paymentInvoicePeriod
          paymentInvoicePeriodCustomDay
          realEstateAgency
          realEstateTax
          remittanceInformation
          rentalGuaranty {
            amount
            type
            financialInstitution
          }
          signatureDate
          startDate
          status
          totalInitialRentalPrice
          totalRentalPrice
          type
          subletting
          vatRateRentId
          bankAccountId
          readers
          readId
          clientId
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        technicId
        ticketId
        ticket {
          id
          assignedAt
          assignedToId
          buildingId
          closedAt
          contactId
          content
          createdAt
          emailMessageId
          emailReferences
          parentId
          plannedAt
          referenceCode
          sourceType
          status
          subject
          unitId
          unread
          updatedAt
          readers
          readId
          clientId
          _version
          _deleted
          _lastChangedAt
        }
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;

/**
 * We are removing linked entities because Technic is handled by custom lambda authorizer.
 * We need this because auth methods are not inter-compatible. So we cannot have technic.linkedEntity in query.
 */
export const syncTechnics = /* GraphQL */ `
  query SyncTechnics($filter: ModelTechnicFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncTechnics(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        type
        contractNumber
        maintenanceHistory {
          contactId
          customValues {
            name
            value
          }
          date
          fileId
          id
          maintenanceSchemaId
        }
        technicLibraryId
        technicName
        lastControlDate
        status
        utilityType
        utilityEanCode
        utilityMeterNumber
        utilityDistributorId
        utilityHistory {
          reading
          secondReading
          date
          reason
        }
        customValues {
          name
          value
        }
        buildingId
        unitId
        leaseId
        contactId
        originalTechnicId
        replacedTechnicId
        certificateIds
        communicationSettingsProfileId
        readers
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;

export const getTechnic = /* GraphQL */ `
  query GetTechnic($id: ID!) {
    getTechnic(id: $id) {
      id
      type
      contractNumber
      maintenanceHistory {
        contactId
        customValues {
          name
          value
        }
        date
        fileId
        id
        maintenanceSchemaId
      }
      technicLibraryId
      technicName
      lastControlDate
      status
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      customValues {
        name
        value
      }
      buildingId
      unitId
      leaseId
      contactId
      originalTechnicId
      replacedTechnicId
      certificateIds
      communicationSettingsProfileId
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const createTechnic = /* GraphQL */ `
  mutation CreateTechnic($input: CreateTechnicInput!, $condition: ModelTechnicConditionInput) {
    createTechnic(input: $input, condition: $condition) {
      id
      type
      contractNumber
      maintenanceHistory {
        contactId
        customValues {
          name
          value
        }
        date
        fileId
        id
        maintenanceSchemaId
      }
      technicLibraryId
      technicName
      lastControlDate
      status
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityHistory {
        reading
        date
        reason
        secondReading
      }
      customValues {
        name
        value
      }
      buildingId
      unitId
      leaseId
      contactId
      originalTechnicId
      replacedTechnicId
      certificateIds
      communicationSettingsProfileId
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const deleteTechnic = /* GraphQL */ `
  mutation DeleteTechnic($input: DeleteTechnicInput!, $condition: ModelTechnicConditionInput) {
    deleteTechnic(input: $input, condition: $condition) {
      id
      type
      contractNumber
      maintenanceHistory {
        contactId
        customValues {
          name
          value
        }
        date
        fileId
        id
        maintenanceSchemaId
      }
      technicLibraryId
      technicName
      lastControlDate
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityHistory {
        reading
        date
        reason
      }
      customValues {
        name
        value
      }
      buildingId
      unitId
      leaseId
      contactId
      communicationSettingsProfileId
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const updateTechnic = /* GraphQL */ `
  mutation UpdateTechnic($input: UpdateTechnicInput!, $condition: ModelTechnicConditionInput) {
    updateTechnic(input: $input, condition: $condition) {
      id
      type
      contractNumber
      maintenanceHistory {
        contactId
        customValues {
          name
          value
        }
        date
        fileId
        id
        maintenanceSchemaId
      }
      technicLibraryId
      technicName
      lastControlDate
      status
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityHistory {
        reading
        secondReading
        date
        reason
      }
      customValues {
        name
        value
      }
      buildingId
      unitId
      leaseId
      contactId
      certificateIds
      originalTechnicId
      replacedTechnicId
      communicationSettingsProfileId
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const listInvoicesForLatePaymentFilter = /* GraphQL */ `
  query ListInvoices($filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        leaseId
        dueDate
        invoiceDate
        amount
        creditNote
        _deleted
      }
      nextToken
    }
  }
`;

export const syncInvoices = /* GraphQL */ `
  query SyncInvoices($filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncInvoices(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        amount
        bankAccountId
        communicationId
        createdAt
        creditNote
        creditNoteLabel
        dueDate
        invoiceDate
        invoiceNumber
        leaseId
        paid
        status
        receiptNumber
        reminderDates
        remittanceInformation
        statementId
        type
        unitId
        readers
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const syncChargesForFolders = /* GraphQL */ `
  query SyncCharges($filter: ModelChargeFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncCharges(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        status
        documentId
        draftFromOcr
        postings {
          items {
            id
            buildingId
            unitId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const getStatementAttachSupportingDocuments = /* GraphQL */ `
  query GetStatement($id: ID!) {
    getStatement(id: $id) {
      id
      attachSupportingDocuments
      __typename
    }
  }
`;

export const syncChargeStatementsWithDocuments = /* GraphQL */ `
  query SyncChargeStatements(
    $filter: ModelChargeStatementFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncChargeStatements(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        chargeId
        statementId
        charge {
          id
          documentId
          invoiceDate
          totalAmount
          contractor {
            id
            commercialName
            companyName
            firstName
            lastName
            __typename
          }
          document {
            id
            bucket
            categoryId
            foreignKey
            foreignTableName
            key
            mimeType
            region
            size
            readers
            readId
            clientId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const syncCharges = /* GraphQL */ `
  query SyncCharges($filter: ModelChargeFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncCharges(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        status
        invoiceDate
        paymentDueDate
        archivedDate
        periodFrom
        periodTo
        totalAmount
        source
        draftFromOcr
        accountingDocumentId
        paid
        remittanceInformation
        note
        createdAt
        creatorEmail
        createdById
        createdBy {
          id
          createdAt
          firstName
          lastName
          companyName
          commercialName
          communicationSettingsProfileId
          businessNumber
          types
          vat
          email
          birthDate
          birthPlace
          nationalRegister
          civility
          addressId
          language
          profileType
          agencyRateDisabled
          status
          sendInvitation
          readers
          readId
          clientId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        contractorId
        contractor {
          id
          createdAt
          firstName
          lastName
          companyName
          commercialName
          communicationSettingsProfileId
          businessNumber
          types
          vat
          email
          birthDate
          birthPlace
          nationalRegister
          civility
          addressId
          language
          profileType
          agencyRateDisabled
          status
          sendInvitation
          readers
          readId
          clientId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        proposedContractors {
          id
          confidence
          __typename
        }
        recipientId
        recipient {
          id
          createdAt
          firstName
          lastName
          companyName
          commercialName
          communicationSettingsProfileId
          businessNumber
          types
          vat
          email
          birthDate
          birthPlace
          nationalRegister
          civility
          addressId
          language
          profileType
          agencyRateDisabled
          status
          sendInvitation
          readers
          readId
          clientId
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        proposedRecipients {
          id
          confidence
          __typename
        }
        customValues {
          name
          value
          __typename
        }
        documentId
        document {
          id
          bucket
          createdAt
          categoryId
          foreignKey
          foreignTableName
          key
          mimeType
          region
          size
          readers
          readId
          clientId
          _ttl
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        postings {
          items {
            id
            buildingId
            unitId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const syncBuildingsForFolders = /* GraphQL */ `
  query syncBuildings($filter: ModelBuildingFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncBuildings(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        name
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const syncUnitsForFolders = /* GraphQL */ `
  query SyncUnits($filter: ModelUnitFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncUnits(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        createdAt
        name
        buildingId
        readers
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const syncUnitLeasesForFolders = /* GraphQL */ `
  query SyncUnitLeases($filter: ModelUnitLeaseFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncUnitLeases(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        leaseId
        lease {
          name
        }
        unitId
        readers
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const syncTechnicsForFolders = /* GraphQL */ `
  query SyncTechnics($filter: ModelTechnicFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncTechnics(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        type
        buildingId
        unitId
        leaseId
        contactId
        originalTechnicId
        replacedTechnicId
        certificateIds
        readers
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;

export const syncContactsForFolders = /* GraphQL */ `
  query SyncContacts($filter: ModelContactFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncContacts(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        createdAt
        firstName
        lastName
        companyName
        commercialName
        types
        status
        jointOwners {
          contactId
          contactPerson
          __typename
        }
        readers
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncFilesForFolders = /* GraphQL */ `
  query SyncFiles($filter: ModelFileFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncFiles(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        bucket
        createdAt
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;

export const getCommunicationStatus = /* GraphQL */ `
  query GetCommunication($id: ID!) {
    getCommunication(id: $id) {
      id
      status
    }
  }
`;

export const getInvoiceType = /* GraphQL */ `
  query GetInvoiceType($id: ID!) {
    getInvoice(id: $id) {
      id
      type
    }
  }
`;

export const syncLeaseActionHistories = /* GraphQL */ `
  query SyncLeaseActionHistories(
    $filter: ModelLeaseActionHistoryFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLeaseActionHistories(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        action
        comment
        contactId
        historyDetails {
          unitId
          newEndDate
          newSignatureDate
          newStartDate
          previousEndDate
          previousSignatureDate
          previousStartDate
        }
        leaseId
        communicationId
        communication {
          id
          status
        }
        signatureDocumentId
        status
        communicationChannel
        communicationSendDate
        communicationByPlatform
        endReason
        endReasonOwnUseRelation
        endReasonOwnUseName
        initiator
        totalAmount
        totalAmountLabel
        automatic
        hasLeaseTypeChanged
        jiraId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
